<!-- @veltra/icons generated sha256:f0d5dbffdacd26e8 gen:8 source:src/svg/normal/arrow-updown.svg -->
<script setup lang="ts">
defineOptions({ name: 'ArrowUpdown' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M11.296 6.487 8 3.154 4.704 6.487a.484.484 0 0 1-.693.012l-.008-.008a.5.5 0 0 1-.01-.707l3.58-3.621a.6.6 0 0 1 .854 0s2.617 2.648 3.58 3.62c.194.197.2.5.004.695l-.008.008a.5.5 0 0 1-.707.001m.056 3.012L8 12.85 4.648 9.5a.49.49 0 0 0-.704.023.487.487 0 0 0 .01.696l3.622 3.622a.6.6 0 0 0 .848 0l3.622-3.622a.487.487 0 0 0 .003-.704.49.49 0 0 0-.697-.015"
    />
  </svg>
</template>
